import { IModel, IModelType } from '../../../types/record/model';
import {
  IModelAPIValidationErrorFactory,
  IModelAPIValidationErrorType,
  ModelAPIRawSuccessResponseType,
  ModelAPIRawValidationErrorType
} from '../../types/model/api-response';
import { nullableToStringList } from '../nullable-to-string-list';

export const IModelFromAPISuccessResponse = ({
  id,
  company_id,
  name,
  status,
  author_id,
  adopted_version_id,
  label_count,
  image_count,
  project_count,
  can_be_used,
  can_be_deleted,
  created_at,
  updated_at
}: ModelAPIRawSuccessResponseType): IModelType =>
  IModel({
    id,
    companyId: company_id,
    name,
    status,
    authorId: author_id,
    adoptedVersionId: adopted_version_id ?? undefined,
    numLabels: label_count,
    numImages: image_count,
    numUseInProjects: project_count,
    canBeUsed: can_be_used,
    canBeDeleted: can_be_deleted,
    dateCreated: new Date(created_at).getTime(),
    dateUpdated: new Date(updated_at).getTime()
  });

export const IModelAPIValidationError = ({
  name,
  company_id,
  adopted_version_id
}: ModelAPIRawValidationErrorType): IModelAPIValidationErrorType =>
  IModelAPIValidationErrorFactory({
    name: nullableToStringList(name),
    companyId: nullableToStringList(company_id),
    adoptedVersionId: nullableToStringList(adopted_version_id)
  });
